import { useNavigate } from "react-router-dom";

export default function BackButton() {
    const navigate = useNavigate();

    return (<button
        className="btn btn-light"
        onClick={() => navigate(-1)}
        title="Back"
    >
        &larr;
    </button>);
}